export enum ShipmentWaypointType {

    PICKUP = "PICKUP",
    DROPOFF = "DROPOFF",
    REST_AREA = "REST_AREA",
    CROSS_DOCK = "CROSS_DOCK"

  }
